<!-- 首页 -->
<template>
    <div class="index-page">
        <!-- 欢迎区域 -->
        <div class="welcome-section">
            <Button class="theme-bc theme-default-color quick-btn" @click="goToAddCode">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="inline-icon">
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                </svg>
                快速生成源码
            </Button>
            <div class="welcome-right">
                <p class="welcome-desc">系统当前运行状态良好，今日新增 {{ todayQrcodeCount }} 条溯源码</p>
            </div>
            
        </div>

        <!-- 统计卡片区域 -->
        <div class="stats-grid">
            <div class="stat-card stat-card-blue">
                <div class="stat-header">
                    <div class="stat-icon stat-icon-blue">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                        </svg>
                    </div>
                    <div class="stat-trend">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>
                        </svg>
                        稳定运行中
                    </div>
                </div>
                <div class="stat-content">
                    <div class="stat-label">服务有效期</div>
                    <div class="stat-value">{{ versions.end_date  }}</div>
                    <div class="stat-sub">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                        </svg>
                        尚余 {{ versions.countdown_days }} 天
                    </div>
                </div>
                <div class="stat-decoration"></div>
            </div>

            <!-- <div class="stat-card stat-card-purple">
                <div class="stat-header">
                    <div class="stat-icon stat-icon-purple">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/>
                        </svg>
                    </div>
                    <div class="stat-trend stat-trend-green">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>
                        </svg>
                    </div>
                </div>
                <div class="stat-content">
                    <div class="stat-label">剩余可生成溯源码量</div>
                    <div class="stat-value">{{ versions.remaining_nums }}</div>
                    <div class="stat-sub">总计码量 {{ versions.qrcode_nums }}</div>
                </div>
                <div class="stat-decoration stat-decoration-purple"></div>
            </div> -->

            <div class="stat-card stat-card-emerald">
                <div class="stat-header">
                    <div class="stat-icon stat-icon-emerald">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
                        </svg>
                    </div>
                    <div class="stat-trend stat-trend-green">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>
                        </svg>
                    </div>
                </div>
                <div class="stat-content">
                    <div class="stat-label">当前溯源码数量</div>
                    <div class="stat-value">{{ qrcode_count }}</div>
                    <!-- <div class="stat-sub">本月新增 +12,400</div> -->
                </div>
                <div class="stat-decoration stat-decoration-emerald"></div>
            </div>

            <div class="stat-card stat-card-amber">
                <div class="stat-header">
                    <div class="stat-icon stat-icon-amber">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M16.5 9.4 7.55 4.24"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.29 7 12 12 20.71 7"/><line x1="12" y1="22" x2="12" y2="12"/>
                        </svg>
                    </div>
                    <div class="stat-trend stat-trend-green">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>
                        </svg>
                    </div>
                </div>
                <div class="stat-content">
                    <div class="stat-label">商品数量</div>
                    <div class="stat-value">{{ product_count }}</div>
                    <!-- <div class="stat-sub">活跃商品 {{ activeProduct || '395' }}</div> -->
                </div>
                <div class="stat-decoration stat-decoration-amber"></div>
            </div>
        </div>

        <!-- 图表区域 -->
        <div class="charts-section">
            <!-- 扫码数据趋势 -->
            <div class="chart-card chart-card-wide">
                <div class="chart-header">
                    <div>
                        <h3 class="chart-title">扫码数据趋势</h3>
                        <p class="chart-desc">{{selectDays}}全国范围内扫码活跃度</p>
                    </div>
                    <Select v-model="dateRange" class="chart-select" @on-change="handleDateChange">
                        <Option  v-for="(d, idx) in dataOPtions " :key="idx" :value="d.value">{{ d.label }}</Option>
                    </Select>
                </div>
                <div class="chart-content">
                    <div class="bar-chart">
                        <div 
                            v-for="(item, index) in chartData" 
                            :key="index" 
                            class="bar-item"
                        >
                            <div class="bar-value">{{ item }}</div>
                            <div class="bar" :style="{ height: (item / maxChartValue * 100) + '%' }"></div>
                        </div>
                    </div>
                    <div class="chart-labels">
                        <span v-for="(label, index) in chartLabels" :key="index">{{ label }}</span>
                    </div>
                </div>
            </div>

            <!-- 异常预警 -->
            <div class="chart-card alert-card">
                <div class="chart-header">
                    <h3 class="chart-title">异常预警</h3>
                </div>
                <div class="alert-list" v-if="exceptions_list.length > 0">
                    <div class="alert-item alert-urgent" v-for="(e, idx) in exceptions_list" :key="idx">
                        <div class="alert-header">
                            <div class="alert-title">{{ e.title }}</div>
                            <div class="alert-time">{{ e.created_at }}</div>
                        </div>
                        <p class="alert-desc">{{ e.content }}</p>
                    </div>
                    
                </div>
                
                <div class="alert-list" v-else>
                    暂无最新预警
                </div>
                <Button class="view-all-btn" @click="openWarningModal">查看全部消息</Button>
            </div>
        </div>
        
        <!-- 防伪预警弹窗 -->
        <Modal v-model="warningModal" :width="80" :mask-closable="false">
            <div slot="header">
                <div class="modal-header">防伪预警</div>
            </div>
            <div>
                <div class="flex-sb">
                    <div class="mr24 modal-box">
                        <Select
                            class="w200 mr24 mb12"
                            v-model="storePramsModal.type"
                            clearable
                            filterable
                            placeholder="请选择"
                        >
                            <Option
                                v-for="item in typeList"
                                :value="item.id"
                                :key="item.id"
                            >{{ item.name }}</Option>
                        </Select>
                        <Select
                            class="w200 mr24 mb12"
                            v-model="storePramsModal.status"
                            clearable
                            filterable
                            placeholder="请选择"
                        >
                            <Option
                                v-for="item in statusList"
                                :value="item.id"
                                :key="item.id"
                            >{{ item.name }}</Option>
                        </Select>
                        <Input
                            class="w200 mr24 mb12"
                            type="text"
                            v-model="storePramsModal.qrcode_number"
                            placeholder="请输入溯源码编码"
                        ></Input>
                        <DatePicker
                            class="w200 mr24 mb12"
                            type="daterange"
                            split-panels
                            placement="bottom-start"
                            placeholder="选择日期"
                            separator="至"
                            @on-change="changeDate"
                        ></DatePicker>
                    </div>
                    <div class="modal-btn">
                        <Button class="theme-bc ml24 mb12 search-btn theme-default-color" @click="goSearch">确认搜索</Button>
                    </div>
                </div>
                <Table
                    ref="selection"
                    :columns="columnsModal"
                    :data="dataModal"
                    border
                    @on-selection-change="changeSelection"
                >
                    <template slot-scope="{ row }" slot="title">
                        <div>{{ row.title }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div class="theme-color" v-if="row.status == 1">未读</div>
                        <div v-else-if="row.status == 2">已读</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="success" ghost @click="goDel(1, row)">删除</Button>
                        </div>
                    </template>
                </Table>
                <div class="page_div">
                    <div>
                        <Checkbox class="mr24 ml24" v-model="del_value" @on-change="handleSelectAll">全选</Checkbox>
                        <Button type="error" ghost @click="goDel(0)">删除</Button>
                        <Button type="warning" ghost @click="goReadAll">一键已读</Button>
                    </div>
                    <Page
                        :current="storePramsModal.page"
                        :page-size="storePramsModal.limit"
                        :total="totalModal"
                        show-elevator
                        show-total
                        @on-change="pageChangeModal"
                    />
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        
    </div>

    
</template>
<script>
import { home_infos, home_bar, home_news_list, home_delete_info, home_read_all } from "@/api/index";
export default {
    data() {
        return {
            // 统计卡片数据
            todayQrcodeCount: 0,
            // 图表数据
            dateRange: '1',
            dataOPtions: [
                { label: '最近7天', value: '1' },
                { label: '最近30天', value: '2' },
                { label: '今年', value: '3' },
            ],
            chartData: [],
            chartLabels: [],
            
            // 防伪预警弹窗
            warningModal: false,
            storePramsModal: {
                page: 1,
                limit: 10,
                start_date: "",
                end_date: "",
                type: "",
                status: "",
                qrcode_number: "",
            },
            totalModal: 0,
            columnsModal: [
                { type: "selection", width: 60, align: "center" },
                { type: "index", width: 60, align: "center" },
                { title: "消息内容", key: "content", align: "center" },
                { title: "消息类型", slot: "title", align: "center" },
                // { title: "关联溯源码编码", key: "qrcode_number", align: "center" },
                { title: "时间", key: "handle_time", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "120px" },
            ],
            dataModal: [],
            typeList: [
                { id: -1, name: "全部" },
                { id: 1, name: "防伪预警" },
                { id: 2, name: "防窜货预警" },
            ],
            statusList: [
                { id: -1, name: "全部" },
                { id: 1, name: "未读" },
                { id: 2, name: "已读" },
            ],
            del_id: "",
            delData: [],
            del_value: false,

            versions:{
                countdown_days: '',
                end_date: '',
                name: '',
                qrcode_nums: '',
                remaining_nums: '',
            },
            product_count:0,
            qrcode_count:0,
            exceptions_list:{}
        };
    },
    computed: {
        maxChartValue() {
            return Math.max(...this.chartData);
        },
        selectDays() {
            var v = this.dataOPtions.find(d => d.value === this.dateRange)
            return v.label;
        },
    },
    mounted() {
        this.initData();
        this.getBarChatData();
    },
    methods: {
        initData() {
            this.getVersion();
            // 初始化数据，可以根据需要调用API获取
        },
        goToAddCode() {
            this.$router.push('/admin/code/add');
        },
        getVersion(){
            home_infos().then((res) => {
                this.versions = res.data.infos
                this.qrcode_count = res.data.qrcode_count
                this.product_count = res.data.product_count
                this.todayQrcodeCount = res.data.today_qrcode_count
                this.exceptions_list = res.data.exceptions.data
            });
            
        },
        handleDateChange(){
            this.getBarChatData();
        },
        getBarChatData(){
            home_bar({val:this.dateRange}).then((res) => {
                this.chartLabels = res.data.date
                this.chartData = res.data.num
            });
        },
        // 防伪预警相关方法
        openWarningModal() {
            this.warningModal = true;
            this.getWarningList();
        },
        getWarningList() {
            home_news_list(this.storePramsModal)
                .then((res) => {
                    this.dataModal = res.data.data;
                    this.totalModal = res.data.total;
                    if (!res.data.data.length && this.storePramsModal.page != 1) {
                        this.storePramsModal.page--;
                        this.getWarningList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goSearch() {
            this.storePramsModal.page = 1;
            this.getWarningList();
        },
        pageChangeModal(index) {
            this.storePramsModal.page = index;
            this.getWarningList();
        },
        changeDate(e) {
            if (e[0]) {
                this.storePramsModal.start_date = e[0];
                this.storePramsModal.end_date = e[1];
            } else {
                this.storePramsModal.start_date = "";
                this.storePramsModal.end_date = "";
            }
        },
        goDel(index, row) {
            if (index == 0 && this.delData.length == 0) {
                this.$Message.error("请选择");
                return;
            }
            this.$Modal.confirm({
                title: "删除提示",
                content: "是否确认删除防伪预警消息，删除后将无法恢复！",
                onOk: () => {
                    if (index == 0) {
                        var del_id = [];
                        this.delData.forEach((item) => {
                            del_id.push(item.id);
                        });
                        this.del_id = del_id.join(",");
                        home_delete_info({ id: this.del_id })
                            .then((res) => {
                                this.getWarningList();
                                this.del_value = false;
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    } else if (index == 1) {
                        home_delete_info({ id: row.id })
                            .then((res) => {
                                this.getWarningList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
        changeSelection(e) {
            this.delData = e;
            if (this.dataModal.length === e.length) {
                this.del_value = true;
            } else {
                this.del_value = false;
            }
        },
        handleSelectAll(e) {
            if (e == true) {
                this.delData = this.dataModal;
                this.$refs.selection.selectAll(true);
            } else {
                this.$refs.selection.selectAll(false);
            }
        },
        goReadAll() {
            home_read_all()
                .then((res) => {
                    this.getWarningList();
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
    },
};
</script>

<style scoped>
/* 页面容器 */
.index-page {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

/* 欢迎区域 */
.welcome-section {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.welcome-desc {
    font-size: 14px;
    font-weight: 500;
    color: #64748b;
}

.welcome-right {
    margin-left:20px
}

.quick-btn {
    padding: 10px 20px;
    border-radius: 12px;
    font-weight: 700;
    font-size: 14px;
    border: none;
    display: flex;
    align-items: center;
    gap: 8px;
}

.inline-icon {
    width: 14px;
    height: 14px;
}

/* 统计卡片网格 */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
}

.stat-card {
    background: #ffffff;
    border-radius: 24px;
    padding: 24px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
}

.stat-card:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
}

.stat-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
    position: relative;
    z-index: 1;
}

.stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.stat-icon-blue {
    background: rgba(37, 99, 235, 0.1);
    color: #2563eb;
}

.stat-icon-emerald {
    background: rgba(16, 185, 129, 0.1);
    color: #10b981;
}

.stat-icon-amber {
    background: rgba(245, 158, 11, 0.1);
    color: #f59e0b;
}

.stat-icon-purple {
    background: rgba(139, 92, 246, 0.1);
    color: #8b5cf6;
}

.stat-trend {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding: 4px 8px;
    border-radius: 8px;
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
}

.stat-trend-green {
    background: rgba(16, 185, 129, 0.1);
    color: #10b981;
}

.stat-content {
    position: relative;
    z-index: 1;
}

.stat-label {
    font-size: 14px;
    font-weight: 500;
    color: #64748b;
    margin-bottom: 8px;
}

.stat-value {
    font-size: 28px;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.5px;
    margin-bottom: 8px;
}

.stat-sub {
    font-size: 12px;
    font-weight: 500;
    color: #94a3b8;
    display: flex;
    align-items: center;
    gap: 4px;
}

.stat-decoration {
    position: absolute;
    right: -16px;
    bottom: -16px;
    width: 96px;
    height: 96px;
    background: rgba(37, 99, 235, 0.05);
    border-radius: 50%;
    filter: blur(24px);
    transition: all 0.5s ease;
}

.stat-card:hover .stat-decoration {
    transform: scale(1.5);
}

.stat-decoration-emerald {
    background: rgba(16, 185, 129, 0.05);
}

.stat-decoration-amber {
    background: rgba(245, 158, 11, 0.05);
}

.stat-decoration-purple {
    background: rgba(139, 92, 246, 0.05);
}

/* 图表区域 */
.charts-section {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 24px;
}

.chart-card {
    background: #ffffff;
    border-radius: 24px;
    padding: 32px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.chart-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 32px;
}

.chart-title {
    font-size: 18px;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.3px;
    margin-bottom: 4px;
}

.chart-desc {
    font-size: 14px;
    font-weight: 500;
    color: #64748b;
}

.chart-select {
    width: 120px;
}

.chart-content {
    height: 256px;
    display: flex;
    flex-direction: column;
}

.bar-chart {
    flex: 1;
    display: flex;
    align-items: flex-end;
    gap: 8px;
    padding: 0 8px;
}

.bar-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    position: relative;
}

.bar-value {
    font-size: 10px;
    font-weight: 700;
    color: #94a3b8;
    margin-bottom: 8px;
    opacity: 0;
    transition: opacity 0.3s;
}

.bar-item .bar-value {
    opacity: 1;
}

.bar {
    width: 100%;
    background: linear-gradient(180deg, rgba(37, 99, 235, 0.1) 0%, rgba(37, 99, 235, 1) 100%);
    border-radius: 8px 8px 0 0;
    transition: all 0.3s ease;
    min-height: 4px;
}

.bar-item .bar {
    background: linear-gradient(180deg, rgba(37, 99, 235, 0.2) 0%, rgba(37, 99, 235, 1) 100%);
    transform: scaleY(1.05);
    transform-origin: bottom;
}

.chart-labels {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    padding: 0 8px;
}

.chart-labels span {
    font-size: 10px;
    font-weight: 700;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

/* 异常预警卡片 */
.alert-card {
    display: flex;
    flex-direction: column;
}

.alert-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.alert-item {
    padding: 16px;
    border-radius: 16px;
    border: 1px solid;
}

.alert-urgent {
    background: rgba(239, 68, 68, 0.05);
    border-color: rgba(239, 68, 68, 0.1);
    color: #dc2626;
}

.alert-warning {
    background: rgba(245, 158, 11, 0.05);
    border-color: rgba(245, 158, 11, 0.1);
    color: #d97706;
}

.alert-info {
    background: rgba(37, 99, 235, 0.05);
    border-color: rgba(37, 99, 235, 0.1);
    color: #2563eb;
}

.alert-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 4px;
}

.alert-title {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.alert-time {
    font-size: 10px;
    opacity: 0.7;
    font-weight: 500;
}

.alert-desc {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.5;
    opacity: 0.9;
}

.view-all-btn {
    width: 100%;
    margin-top: 24px;
    font-size: 14px;
    font-weight: 700;
    color: #2563eb;
    border: 1px solid rgba(37, 99, 235, 0.2);
    border-radius: 16px;
    background: transparent;
}

.view-all-btn:hover {
    background: rgba(37, 99, 235, 0.05);
}

/* 防伪预警弹窗样式 */
.page_div {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.flex-sb {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
}
.flex-sa {
    display: flex;
    align-items: center;
    gap: 8px;
}
.mr24 {
    margin-right: 24px;
}
.ml24 {
    margin-left: 24px;
}
.mb12 {
    margin-bottom: 12px;
}
.w200 {
    width: 200px;
}
.mr12 {
    margin-right: 12px;
}
.modal-header {
    padding: 16px 20px;
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
    border-bottom: 1px solid #e2e8f0;
}
.modal-box {
    padding-bottom: 0 !important;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.modal-btn {
    display: flex;
    flex-direction: row;
}
.read-all-btn {
    color: #64748b;
}
.search-btn {
    order: 1;
}
.theme-color {
    color: #2563eb;
}

/* 响应式 */
@media (max-width: 1400px) {
    .stats-grid {
        grid-template-columns: repeat(2, 1fr);
    }
    .charts-section {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .stats-grid {
        grid-template-columns: 1fr;
    }
    .welcome-section {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }
}
</style>
